import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {KindOfOrder} from "../../../../types/enums";
import {StoreNote} from "../types/StoreNote";

export const useGetStoreNotes = (kindOfOrder: KindOfOrder) => {

    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['store-notes', kindOfOrder],
        queryFn: async () => await apiClient.get('note/store-notes',
            { params: { kindOfOrder: kindOfOrder } }) as StoreNote[]
    });

    return {
        data: data || [],
        isLoading,
        refetch,
        isRefetching
    };
};
